export const environment = {
  production: true,
  mockMode: false,
  jira: {
    clientId: 'CLIENT_ID_MARKER',
    clientSecret: 'CLIENT_SECRET_MARKER',
    baseUrl: 'JIRA_BASE_URL_MARKER',
    redirectUri: 'MY_URL_MARKER/auth-callback',
    authorizationEndpoint: '/rest/oauth2/latest/authorize',
    tokenEndpoint: 'MY_URL_MARKER/auth-token',
    scope: 'READ',
    logoutUrl: '/rest/oauth2/latest/logout'
  },
    api: {
    baseUrl: 'JIRA_BASE_URL_MARKER/rest/api/latest',
    timeout: 30000,
    retryAttempts: 3
  },
  keycloak: {
    url: '{{{KEYCLOAK_URL}}}',
    realm: '{{{KEYCLOAK_REALM}}}',
    clientId: '{{{KEYCLOAK_CLIENT_ID}}}'
  }
};